import React, { useState, useEffect } from "react";
import Card from "../../../components/Card";
import { Row, Col, Button } from "react-bootstrap";
import { toast } from 'react-toastify';
import { postApiCall } from "../../../service/httpCall";
import { API_TTS_PLANS_CREATE } from "../../../service/url";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../utilities/constant";

export default function VoicePlanCreate() {
  const navigate = useNavigate();
  const [planName, setPlanName] = useState("");
  const [buttonDisable, setButtonDisable] = useState(false);
  const [perCharacter, setPerCharacter] = useState("");
  const [perVariable, setPerVariable] = useState("");

  function validateForm() {
    let valid = true;

    if (!planName?.trim() || !perCharacter?.trim() || !perVariable?.trim()) {
      valid = false;
      toast.warning("All fields are required")
    }

    return valid;
  }

  function submitForm(e) {
    e.preventDefault();

    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    let params = {
      plan_name: planName,
      per_character: parseFloat(perCharacter),
      per_variable: parseFloat(perVariable),
    };

    postApiCall(API_TTS_PLANS_CREATE, params)
      .then(onVoicePlanSuccess)
      .catch(onVoicePlanError);
  }

  function onVoicePlanSuccess(resp) {
    toast.success("TTS plan created successfully")
    setTimeout(() => {
      navigate(`/${ROUTES.TTSPLANS.LIST}`);
    }, 1500);
  }

  function onVoicePlanError(err) {
    setButtonDisable(false);
    toast.warning(err)
  }

  return (
    <>
      <div className="mt-5">
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Body>
                <div className="new-trunk-info"></div>
                <form
                  onSubmit={async (e) => {
                    submitForm(e);
                  }}
                >
                  <div className="mb-4">
                    <h5 className="mb-3">ADD TTS PLAN</h5>
                    <Row>
                      <Col md={4}>
                        <label className="form-label">Plan Name <span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          value={planName}
                          onChange={(e) => setPlanName(e.target.value)}
                          placeholder="Plan Name"
                        />
                      </Col>
                      <Col md={4}>
                        <label className="form-label">Per Character<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          value={perCharacter}
                          onChange={(e) => setPerCharacter(e.target.value)}
                          placeholder="Per Character"
                        />
                      </Col>
                      <Col md={4}>
                        <label className="form-label">Per Variable<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          value={perVariable}
                          onChange={(e) => setPerVariable(e.target.value)}
                          placeholder="Per Variable"
                        />
                      </Col>
                    </Row>
                  </div>

                  <Button
                    type={"submit"}
                    variant="btn btn-primary"
                    disabled={
                      buttonDisable ||
                      !planName?.trim() ||
                      !perCharacter?.trim() ||
                      !perVariable?.trim()
                    }
                  >
                    Add TTS Plan &nbsp;
                    {buttonDisable ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <></>
                    )}
                  </Button>
                </form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}
